<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-3 black--text">
                <span class="black--text txt-head"> 1. หลักการและเหตุผล </span>
                <span class="txt-normal" style="text-indent: 16px">
                  (ระบุที่มาและความสำคัญของการดำเนินโครงการแสดงรายละเอียดข้อมูลของปัญหาที่ผู้ประกอบการต้องการพัฒนา
                  และปรับปรุงประสิทธิภาพ
                  และผลลัพธ์ที่คาดว่าจะได้รับจากการนําเทคโนโลยี องค์ความรู้
                  และความช่วยเหลือของคณะผู้เชี่ยวชาญเข้าไปแก้ไขปัญหาและพัฒนากิจการ
                  เพิ่มประสิทธิภาพของกิจการของผู้ประกอบการ ชี้แจง
                  รายละเอียดโดยย่อ)
                </span>
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <Wysiwyg
                theme="3"
                :readonly="isOIC"
                height="250"
                :value="form.principle"
                @onChange="setFormField('principle', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">2. วัตถุประสงค์</span>
            <span class="txt-normal" style="text-indent: 16px">
              (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ
              แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ
              วัตถุประสงค์ของโครงการ)
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.objective"
            @onChange="setFormField('objective', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              3. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.industry_group"
            @onChange="setFormField('industry_group', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import Wysiwyg from "../../../components/input/Wysiwyg.vue";

export default {
  name: "AFormProject",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    Wysiwyg,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState({
      ProjectForm: (state) => state.AForm.ProjectForm,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    if (this.isSameId && !this.masterData.form_b) this.form = this.ProjectForm;
    if (this.masterData.form_b) {
      if (this.masterData.form_b.form_ab_project_info) {
        this.form = this.masterData.form_b.form_ab_project_info;

        console.log("partTwoForm", this.form);
      }
    }
    eventBus.$on("aFormProject", () => {
      eventBus.$emit("aFormProjectSend", this.form);
    });
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped></style>
